var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../../components/UnlinkedApplicationForm";
import AppBody from "../../../../components/AppBody";
import { Button } from "@savvyinsure/react-ui";
import Header from "../../../../components/Header";
import { PHASE } from "../../../../routeConfig";
import { completedPage } from "../../../../lib/Avo";
import { savePolicyHolder } from "../../../../features/unlinked-application/unlinkedApplicationSlice";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import useAppSelector from "../../../../hooks/useAppSelector";
import useMemoryHistory from "../../../../hooks/useMemoryHistory";
var options = [
    {
        min: 0,
        max: 6,
        label: "Less than 6 months",
    },
    {
        min: 6,
        max: 12,
        label: "6 - 12 months",
    },
    { min: 12, max: 24, label: "1 - 2 Years" },
    { min: 24, max: 36, label: "2 - 3 Years" },
    { min: 36, max: null, label: "3+ Years" },
];
export default function UnlinkedApplicationAutoPolicyHolderPolicyTenure() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var currentAutoIssuer = useAppSelector(function (state) { return state.applicant.currentIssuer.auto; });
    var push = useMemoryHistory().push;
    var dispatch = useAppDispatch();
    function handleClick(min, max) {
        return function (ev) {
            var selectedOption = ev.currentTarget.textContent;
            var minTenure = min === 0;
            completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: selectedOption, optionSelected: selectedOption }));
            dispatch(savePolicyHolder(__assign({ tenureWithLatestIssuerInMonths: { min: min, max: max } }, (!minTenure && { continuouslyInsuredDuration: { min: min, max: max } }))));
            push(minTenure
                ? PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER_CONTINUOUSLY_INSURED
                : PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES);
        };
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement(AppBody, null,
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, { className: "pt-14" },
                React.createElement(UnlinkedApplicationForm.Header, { className: "mb-4" },
                    "How long have you been insured by ", currentAutoIssuer === null || currentAutoIssuer === void 0 ? void 0 :
                    currentAutoIssuer.name,
                    "?"),
                React.createElement("div", { className: "space-y-3" }, options.map(function (_a) {
                    var min = _a.min, max = _a.max, label = _a.label;
                    return (React.createElement(Button, { key: label, onClick: handleClick(min, max) }, label));
                }))))));
}
